var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _vm.displayedAlerts.length > 1
        ? _c(
            "v-col",
            {
              staticClass: "d-block pt-0",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "v-alert",
                {
                  staticClass: "py-3 px-1 mb-0",
                  attrs: {
                    type: "warning",
                    color: "orange lighten-1",
                    role: "note"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "prepend",
                        fn: function fn() {
                          return [
                            _c(
                              "v-icon",
                              {
                                staticClass:
                                  "mx-2 d-none d-sm-block white--text"
                              },
                              [_vm._v("mdi-alert-circle-outline")]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1935957781
                  )
                },
                [
                  [
                    _c(
                      "div",
                      {
                        staticClass: "hidden-xs-only"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-space-between align-center"
                          },
                          [
                            _vm._v(
                              " You have multiple service notifications. "
                            ),
                            _c(
                              "gg-btn",
                              {
                                staticClass: "flex-shrink mr-2",
                                attrs: {
                                  color: "orange",
                                  to: {
                                    name: "downtime"
                                  },
                                  role: "link"
                                }
                              },
                              [_vm._v(" View Them ")]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "hidden-sm-and-up"
                      },
                      [
                        _vm._v(" You have multiple service notifications. "),
                        _c(
                          "router-link",
                          {
                            staticClass: "white--text fw-bold underline",
                            attrs: {
                              to: {
                                name: "downtime"
                              }
                            }
                          },
                          [_vm._v("View Them")]
                        ),
                        _vm._v(". ")
                      ],
                      1
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        : _vm._l(_vm.displayedAlerts, function(alert) {
            return _c(
              "v-col",
              {
                key: alert.id,
                staticClass: "d-block pt-0",
                attrs: {
                  cols: "12"
                }
              },
              [
                _c(
                  "v-alert",
                  {
                    staticClass: "py-3 px-1 mb-0",
                    attrs: {
                      type: "warning",
                      color: "orange lighten-1",
                      role: "note"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "prepend",
                          fn: function fn() {
                            return [
                              _c(
                                "v-icon",
                                {
                                  staticClass:
                                    "mx-2 d-none d-sm-block white--text"
                                },
                                [_vm._v("mdi-alert-circle-outline")]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    [
                      _c(
                        "div",
                        {
                          staticClass: "hidden-xs-only"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-space-between align-center"
                            },
                            [
                              _vm._v(" " + _vm._s(alert.title) + " "),
                              _c(
                                "gg-btn",
                                {
                                  staticClass: "flex-shrink mr-2",
                                  attrs: {
                                    color: "orange",
                                    to: {
                                      name: "downtime-single",
                                      params: {
                                        id: alert.id
                                      }
                                    },
                                    role: "link"
                                  }
                                },
                                [_vm._v(" View ")]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "hidden-sm-and-up"
                        },
                        [
                          _vm._v(" " + _vm._s(alert.title) + ". "),
                          _c(
                            "router-link",
                            {
                              staticClass: "white--text fw-bold underline",
                              attrs: {
                                to: {
                                  name: "downtime-single",
                                  params: {
                                    id: alert.id
                                  }
                                }
                              }
                            },
                            [_vm._v("View")]
                          ),
                          _vm._v(". ")
                        ],
                        1
                      )
                    ]
                  ],
                  2
                )
              ],
              1
            )
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }